import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-area-quienes',
  templateUrl: './block-area-quienes.component.html',
  styleUrls: ['./block-area-quienes.component.css']
})
export class BlockAreaQuienesComponent implements OnInit {

  @Input() blockAreaQuienes_items: any[] = []

  constructor() { }

  ngOnInit(): void {

  }

}
